import React, { useState } from "react";
import useCheckIfUserIsSubscribed from "api/SubscriptionsResource/useCheckIfUserIsSubscribed";
import AddSeatsModal from "components/AddSeatsModal";
import { FiPlus } from "react-icons/fi";
import { MdEventSeat } from "react-icons/md";
import useAuthStore from "store/authStore";
import { Role } from "utils/server-constants/roles";
import { Link } from "react-router-dom";

const SubscriptionSeatsCard = () => {
	const [showAddSeatsModal, setShowAddSeatsModal] = useState(false);
	const hasRoles = useAuthStore((state) => state.hasRoles);

	const { data: isSubscribed, isLoading } = useCheckIfUserIsSubscribed();

	const currentSubscription = isSubscribed?.data || null;
	const isInstitutional = currentSubscription?.category === "institution";
	const canAddSeats = isInstitutional && hasRoles([Role.Institution, Role.Educator]);
	const seatsPurchased = currentSubscription?.seats_purchased || currentSubscription?.number_of_seats || 1;
	const maxAllocationsPerSeat =
		currentSubscription?.max_allocations_per_seat || currentSubscription?.max_number_of_books || 0;

	if (isLoading) {
		return null; // Don't show loading state, just render nothing while checking
	}

	// Only show this card when user can actually add seats
	if (!canAddSeats) {
		return null;
	}

	return (
		<>
			<div className="w-full bg-gradient-to-r from-akgreen to-akgreener rounded-lg shadow-lg p-6 text-white">
				<div className="flex items-center justify-between">
					<div className="flex items-start gap-4">
						<div className="bg-white bg-opacity-20 rounded-full p-4">
							<MdEventSeat size={40} className="text-white" />
						</div>
						<div>
							<h3 className="text-2xl font-bold mb-2">Institution Seat Capacity</h3>
							<div className="flex items-center gap-6 mb-2">
								<div>
									<p className="text-sm opacity-90">Current Seats</p>
									<p className="text-3xl font-bold">{seatsPurchased}</p>
								</div>
								<div className="h-12 w-px bg-white opacity-30"></div>
								<div>
									<p className="text-sm opacity-90">Allocations / Seat</p>
									<p className="text-lg font-semibold">{maxAllocationsPerSeat}</p>
								</div>
								<div className="h-12 w-px bg-white opacity-30"></div>
								<div>
									<p className="text-sm opacity-90">Plan</p>
									<p className="text-lg font-semibold">{currentSubscription?.name || "N/A"}</p>
								</div>
							</div>
							<p className="text-sm opacity-90">
								Add seats when you need to allocate picked books to more unique students.
							</p>
						</div>
					</div>
					<div className="flex flex-col gap-3">
						<button
							onClick={() => setShowAddSeatsModal(true)}
							className="px-6 py-3 bg-white text-akgreen rounded-lg hover:shadow-xl transition-all flex items-center gap-2 font-semibold"
						>
							<FiPlus size={20} />
							Add Seats
						</button>
						<Link
							to="/my-account/subscriptions"
							className="px-6 py-3 bg-white bg-opacity-20 hover:bg-opacity-30 rounded-lg transition-all text-center text-sm"
						>
							View Subscription Details
						</Link>
					</div>
				</div>
			</div>

			<AddSeatsModal
				visible={showAddSeatsModal}
				onHide={() => setShowAddSeatsModal(false)}
				subscription={currentSubscription}
			/>
		</>
	);
};

export default SubscriptionSeatsCard;
